import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '@/modules/localizations';
import { Button, Icon, type ButtonProps, type IconProps } from '@/modules/ui';
import { visibleOnRowHoverClassName } from '@/modules/ui/components/Table/Table.rules';

import * as felaRules from './VaultRowActionButton.rules';

export interface VaultRowActionButtonProps {
    label: MessageKey;
    icon: IconProps['type'];
    color: ButtonProps['color'];
    testId: string;
    /** Required: it was optional only while P4's Edit action was deliberately inert. */
    onClick: () => void;
}

export const VaultRowActionButton = ({ label, icon, color, testId, onClick }: VaultRowActionButtonProps) => (
    <Button
        type='text'
        color={color}
        icon={<Icon type={icon} width={16} height={16} />}
        customStyle={felaRules.button}
        className={visibleOnRowHoverClassName}
        onClick={onClick}
        data-testid={testId}
    >
        <FormattedMessage id={label} />
    </Button>
);
